import { render, staticRenderFns } from "./DailyMenu.vue?vue&type=template&id=c900c84a&scoped=true&"
import script from "./DailyMenu.vue?vue&type=script&lang=js&"
export * from "./DailyMenu.vue?vue&type=script&lang=js&"
import style0 from "./DailyMenu.vue?vue&type=style&index=0&id=c900c84a&lang=scss&scoped=true&"
import style1 from "./DailyMenu.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c900c84a",
  null
  
)

export default component.exports